import { BB, GRAY30, GRAY80, ButtonText2 } from 'global-styles';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styled, { css } from 'styled-components';
import { TabItem } from './ProductSectionTabTemplate';

interface Props {
  isFloatTab: boolean;
  tabItems: TabItem[];
}

const ProductTabMenu = ({ isFloatTab, tabItems }: Props) => {
  const { asPath } = useRouter();

  return (
    <ProductTabMenuContainer isFloatTab={isFloatTab}>
      <ul className="tab-inner-wrapper">
        {tabItems.map(tab => (
          <HashTabItem
            key={tab.label}
            isSelected={asPath.toLowerCase().includes(tab.pathname)}
          >
            <Link
              href={{ pathname: tab.pathname, hash: 'product-section' }}
              scroll={false}
            >
              <ButtonText2 as="a">{tab.label}</ButtonText2>
            </Link>
          </HashTabItem>
        ))}
      </ul>
    </ProductTabMenuContainer>
  );
};

export default ProductTabMenu;

const ProductTabMenuContainer = styled.div<{ isFloatTab: boolean }>`
  width: 100vw;
  display: flex;
  justify-content: center;
  height: 62px;
  position: relative;
  z-index: 10;
  background-color: #fff;
  .tab-inner-wrapper {
    height: 100%;
    max-width: 1200px;
    display: flex;
    transition: top 0.25s cubic-bezier(0.1, 0.57, 0.1, 1);
    position: relative;
    z-index: 100;
    background-color: transparent;

    /* remove scrollbar */
    overflow-x: scroll;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }

    @media screen and (min-width: 1440px) {
      width: 100%;
      max-width: 1200px;
    }
    @media screen and (min-width: 1240px) and (max-width: 1439px) {
      width: calc(100% - 192px);
    }
    @media screen and (min-width: 905px) and (max-width: 1239px) {
      width: calc(100% - 112px);
    }
    @media screen and (max-width: 904px) and (min-width: 600px) {
      width: 100%;
    }
    @media screen and (max-width: 599px) {
      width: 100%;
    }
  }
  .tab-inner-wrapper::after {
    position: absolute;
    height: 1px;
    width: 100%;
    min-width: 480px;
    content: '';
    display: block;
    background: ${GRAY80};
    bottom: 0px;
  }
  &::after {
    transform: scaleX(0);
    transition: 0.2s transform cubic-bezier(0.1, 0.57, 0.1, 1);
    position: absolute;
    height: 1px;
    width: 100%;
    min-width: 480px;
    content: '';
    display: block;
    background: ${GRAY80};
    bottom: 0px;
  }
  ${({ isFloatTab }) =>
    isFloatTab
      ? css`
          position: fixed;
          width: 100vw !important;
          margin: 0 !important;
          top: 72px;
          &::after {
            transform: scaleX(1);
          }
          .tab-inner-wrapper::after {
            width: 100vw !important;
          }
          @media screen and (min-width: 905px) {
            top: 60px;
          }
          @media screen and (max-width: 904px) and (min-width: 600px) {
            top: 52px;
          }
          @media screen and (max-width: 599px) {
            top: 44px;
          }
        `
      : css`
          position: 'static';
          top: 'unset';
        `}
`;

const HashTabItem = styled.li<{ isSelected: boolean }>`
  min-width: 160px;
  height: 60px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  & > a {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    transition: all 0.3s ease-in-out;
    color: ${({ isSelected }) => (isSelected ? BB : GRAY30)} !important;
  }
  @media (hover: hover) {
    &:hover::after {
      transform: scaleX(1);
    }
  }

  &::after {
    transition: transform 0.3s ease-in-out;
    transform: ${({ isSelected }) => (isSelected ? 'scaleX(1)' : 'scaleX(0)')};
    display: block;
    content: '';
    position: absolute;
    bottom: -2px;
    height: 2px;
    width: 160px;
    background: #2564ce;
    transform-origin: center;
    z-index: 9999;
  }
`;
